<template>
  <print v-if="isPrint" :board="board" :form="form" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      field-name="회사명(필수)"
      :options="[
        { type: 'text', label: '점검자', value: '점검자' },
        { type: 'date', label: '점검일(필수)', value: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" :title="$t('예방 점검표')" contentBefore="•" v-model="form.inspectList" class="mt-28px" />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i>{{ $t("결재란") }}</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import { required } from "vuelidate/lib/validators";
import Print from "./Print.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    Print,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
    TableInspectMerge,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
        점검자: { required },
        점검일: { required },
      },
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "안전·보건 합동점검표",
      form: {
        stdInfo: {},
        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },

        inspectList: [
          {
            content: "<span class='font-normal'>작업관계자 외 출입금지 조치를 하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제20조)</span>",
            isChecked: "",
            title: "출입금지",
          },
          {
            content: "<span class='font-normal'>안전하게 통행할 수 있도록 통로의 채광 또는 조명시설이 적정한지(75럭스(lux) 이상)</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제21조)</span>",
            isChecked: "",
            title: "안전통로",
          },
          {
            content: "<span class='font-normal'>통로가 안전하게 사용될 수 있도록 유지하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제22조)</span>",
            isChecked: "",
            title: "안전통로",
          },
          {
            content: "<span class='font-normal'>작업계획서 작성 대상 작업 시 사전조사 및 그 결과를 기록 보존하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제22조)</span>",
            isChecked: "",
            title: "작업계획서·작업지휘자",
          },
          {
            content: "<span class='font-normal'>사전조사 결과를 고려하여 적정한 작업계획서를 작성하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제38조)</span>",
            isChecked: "",
            title: "작업계획서·작업지휘자",
          },
          {
            content: "<span class='font-normal'>작업계획서의 내용을 해당 근로자에게 알리고 그 계획에 따라 작업을 하도록 하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제38조)</span>",
            isChecked: "",
            title: "작업계획서·작업지휘자",
          },
          {
            content: "<span class='font-normal'>작업지휘자, 유도자, 신호수 등을 지정·배치하여 통제에 따라 작업을 진행하는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제39조, 40조)</span>",
            isChecked: "",
            title: "작업계획서·작업지휘자",
          },
          {
            content: "<span class='font-normal'>기계·장비 등의 결함, 작동이상 유무 및 방호장치 작동 여부를 확인하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제35조)</span>",
            isChecked: "",
            title: "기계·기구 위험예방",
          },
          {
            content: "<span class='font-normal'>기계·기구·설비 등을 목적 외의 용도로 사용하지 않도록 하고 있는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제96조)</span>",
            isChecked: "",
            title: "기계·기구 위험예방",
          },
          {
            content: "<span class='font-normal'>차량계 하역운반기계 및 건설기계 사용 시 제한속도를 지정하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(안전보건기준에 관한 규칙 제98조)</span>",
            isChecked: "",
            title: "기계·기구 위험예방",
          },
          {
            content: "<span class='font-normal'>자격·면허·경험 또는 기능이 필요한 작업 시 자격 등이 있는 자를 작업에 배치하였는지</span><br>" + "<span class='font-normal' style='color:#6C6C6C'>(산업안전보건법 제140조)</span>",
            isChecked: "",
            title: "취업제한",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "회사명을 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검자"].required) return "점검자를 반드시 입력해야 합니다";
        else if (!this.$v.form.stdInfo["점검일"].required) return "점검일을 반드시 입력해야 합니다";
      }
    },
  },
};
</script>
